import * as angular from "angular";
import {CommissionPaymentDetailsModel} from "../models/commission-payment-details.model";
import {CommissionModel} from "../models/commission.model";

export class CommissionRequestService {

  /* @ngInject */
  constructor(private $commission, private CommissionsAPI) {
  }

  // ******************************
  // External methods
  // ******************************


  addCredit(payload) {
    const api = this.CommissionsAPI.actions.addCredit;
    return this.$$call(api, {}, payload, {});
  }

  addDebt(payload) {
    const api = this.CommissionsAPI.actions.addDebt;
    return this.$$call(api, {}, payload, {});
  }

  exportCommissions(queryParams, payload) {
    const api = this.CommissionsAPI.actions.export;
    return this.$$call(api, queryParams, payload, {});
  }

  getTotals(payload) {
    const api = this.CommissionsAPI.actions.totals;
    return this.$$call(api, payload, {}, {});
  }

  payManually(commissionPaymentDetails: CommissionPaymentDetailsModel, queryParams) {
    const api = this.CommissionsAPI.actions.payManually;
    return this.$$call(api, {
      id: queryParams.commissionIds,
      excludeId: queryParams.excludeIds,
      accountIds: queryParams.accountIds,
      agentIds: queryParams.agentIds,
      from: queryParams.from,
      to: queryParams.to
    }, commissionPaymentDetails, {});
  }

  pay(payload) {
    const api = this.CommissionsAPI.actions.pay;
    return this.$$call(api, {}, payload, {});
  }

  editPrice(commissionId: string, price: number, comment: string) {
    const api = this.CommissionsAPI.actions.editPrice;
    return this.$$call(api, {}, {manualCommission: price, comment: comment}, {id: commissionId});
  }

  bulkEditPrice(query: any, price: number, comment: string) {
    const api = this.CommissionsAPI.actions.bulkEditPrice;
    return this.$$call(api, query, {manualCommission: price, comment: comment}, {});
  }

  updateOne(commission: CommissionModel) {
    const api = this.CommissionsAPI.actions.updateOne;
    return this.$$call(api, {}, commission, {commissionId: commission.id});
  }

  deleteOne(id: string) {
    const api = this.CommissionsAPI.actions.deleteOne;
    return this.$$call(api, {}, {}, {id: id});
  }

  getLogsTimeline(commissionId: string) {
    const api = this.CommissionsAPI.actions.getLogsTimeline;
    return this.$$call(api, {}, {}, {commissionId: commissionId});
  }


  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$commission().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.commissions')
  .service('commissionRequestService', CommissionRequestService);
